import { Badge } from '../../../components/ui/Badge';

interface CategoryCellProps {
  names: string[];
  count: number;
}

/**
 * The "Product Category" column: the RFP's own category, then a "+N" pill counting the other
 * categories its products belong to. An RFP's lines usually span several catalogue groups, and
 * the column used to show only the primary one.
 */
export function CategoryCell({ names, count }: CategoryCellProps) {
  if (names.length === 0) {
    return <span className="text-muted">—</span>;
  }

  const [first, ...rest] = names;

  return (
    <span className="category-cell" title={names.join(', ')}>
      <span className="category-cell__name">{first}</span>
      {rest.length > 0 ? (
        <Badge variant="info" title={`${count} categories`}>
          {`+${rest.length}`}
        </Badge>
      ) : null}
    </span>
  );
}
